var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { or, readOnly, equal } from '@ember/object/computed';
import { isEmpty, isNone } from '@ember/utils';
import EmberObject, { computed, get } from '@ember/object';
import { formatName } from '@square/dashboard-items-data/utils/inventory-event-format';
import { InventoryEventType, InventoryEventVendor } from '@square/dashboard-items-data/models/squareup/inventory/v3/inventory-event';
import DecimalStockCount from '@square/dashboard-items-data/models/decimal-stock-count';
import { CompositionType } from '@square/dashboard-items-data/models/composition';
const countEditableEventTypes = new Set([InventoryEventType.LOSS, InventoryEventType.DAMAGED]);
let InventoryEventWrapper = (_dec = readOnly('inventoryEvent.eventType'), _dec2 = readOnly('inventoryEvent.stockCount'), _dec3 = readOnly('inventoryEvent.itemName'), _dec4 = readOnly('inventoryEvent.variationName'), _dec5 = readOnly('inventoryEvent.variationSku'), _dec6 = readOnly('inventoryEvent.variationUpc'), _dec7 = readOnly('inventoryEvent.defaultCost'), _dec8 = readOnly('inventoryEvent.componentInformation'), _dec9 = readOnly('inventoryEvent.rootAdjustmentInformation'), _dec10 = readOnly('inventoryEvent.defaultVendor'), _dec11 = readOnly('inventoryEvent.objectDeleted'), _dec12 = readOnly('inventoryEvent.connectOauthClientName'), _dec13 = readOnly('inventoryEvent.maxEditableQuantity'), _dec14 = readOnly('inventoryEvent.vendors'), _dec15 = readOnly('inventoryEvent.linkedRestockOriginalSaleUnitToken'), _dec16 = computed('isRecount', 'inventoryEvent.{adjustment,inferredAdjustment}'), _dec17 = computed('eventType', 'rootAdjustmentInformation.compositionType'), _dec18 = readOnly('adjustment.adjustmentGroup.rootAdjustmentToken'), _dec19 = computed('isReceivedWithStockConversion', 'rootAdjustmentToken', 'adjustment.token'), _dec20 = computed('isReceivedWithStockConversion', 'inventoryEvent.measurementUnit', 'rootAdjustmentInformation.measurementUnit'), _dec21 = readOnly('adjustment.productIdentifier.merchantCatalogToken'), _dec22 = computed('adjustment.quantity', 'stockCount.quantity'), _dec23 = readOnly('quantity.count'), _dec24 = computed('isReceivedWithStockConversion', 'adjustment.quantityDecimal', 'rootAdjustmentInformation.quantityDecimal', 'stockCount.quantityDecimal'), _dec25 = computed('adjustment.quantityDecimal'), _dec26 = computed('maxEditableQuantity.{count,fractionalCount}'), _dec27 = computed('adjustment.fromState.unitToken', 'stockCount.state.unitToken'), _dec28 = computed('adjustment.toState.unitToken', 'stockCount.state.unitToken'), _dec29 = computed('adjustment.occurredAt', 'stockCount.countedAt'), _dec30 = computed('adjustment.adjustedBy', 'stockCount.countedBy'), _dec31 = computed('itemName', 'variationName', 'objectDeleted'), _dec32 = readOnly('adjustment.purchaseOrderToken'), _dec33 = readOnly('adjustment.transferOrderToken'), _dec34 = readOnly('adjustment.bulkAdjustToken'), _dec35 = readOnly('adjustment.totalCost'), _dec36 = computed('adjustment.{cost,totalCost}', 'isReceivedWithStockConversion', 'quantityDecimal', 'rootAdjustmentInformation.quantityDecimal'), _dec37 = computed('adjustment.{totalCost,unitCost}', 'isReceivedWithStockConversion', 'quantityDecimal', 'rootAdjustmentInformation.quantityDecimal'), _dec38 = computed('eventType', 'purchaseOrderToken'), _dec39 = equal('eventType', InventoryEventType.RECOUNT), _dec40 = computed('adjustment.{fromState.sqState,toState.sqState}', 'adjustmentQuantityDecimal', 'isRecount'), _dec41 = computed('adjustment.{fromState.sqState,toState.sqState}'), _dec42 = computed('adjustment.{fromState.sqState,toState.sqState}'), _dec43 = computed('eventType', 'isManualReceive', 'isUnlinkedRestock', 'maxEditableQuantity.count'), _dec44 = computed('transferOrderToken', 'eventType', 'fromUnitToken', 'toUnitToken', 'adjustment.{fromState.sqState,toState.sqState}'), _dec45 = computed('transferOrderToken', 'eventType', 'fromUnitToken', 'toUnitToken', 'adjustment.{fromState.sqState,toState.sqState}'), _dec46 = or('isManualReceive', 'isPositiveRecount', 'isUnlinkedRestock', 'isUntrackedSale'), _dec47 = or('isCostEditable', 'isUntrackedSale'), _dec48 = readOnly('adjustment.totalSalesPrice'), _dec49 = computed('eventType', 'adjustment.{fromState.sqState,toState.sqState}'), _class = class InventoryEventWrapper extends EmberObject {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "inventoryEvent", null);
    // InventoryEvent proto fields.
    // See https://prototype.sqprod.co/#/docs/squareup.inventory.v3.InventoryEvent.
    _initializerDefineProperty(this, "eventType", _descriptor, this);
    _initializerDefineProperty(this, "stockCount", _descriptor2, this);
    _initializerDefineProperty(this, "itemName", _descriptor3, this);
    _initializerDefineProperty(this, "variationName", _descriptor4, this);
    _initializerDefineProperty(this, "variationSku", _descriptor5, this);
    _initializerDefineProperty(this, "variationUpc", _descriptor6, this);
    _initializerDefineProperty(this, "defaultCost", _descriptor7, this);
    _initializerDefineProperty(this, "componentInformation", _descriptor8, this);
    _initializerDefineProperty(this, "rootAdjustmentInformation", _descriptor9, this);
    /**
     * Contains the item variation's default vendor, if it has one.
     * Only populated if "include_default_vendor" is set to true on the inventory events query.
     * @type {Vendor}
     */
    _initializerDefineProperty(this, "defaultVendor", _descriptor10, this);
    _initializerDefineProperty(this, "objectDeleted", _descriptor11, this);
    _initializerDefineProperty(this, "connectOauthClientName", _descriptor12, this);
    _initializerDefineProperty(this, "maxEditableQuantity", _descriptor13, this);
    _initializerDefineProperty(this, "vendors", _descriptor14, this);
    _initializerDefineProperty(this, "linkedRestockOriginalSaleUnitToken", _descriptor15, this);
    _initializerDefineProperty(this, "rootAdjustmentToken", _descriptor16, this);
    _initializerDefineProperty(this, "productToken", _descriptor17, this);
    _initializerDefineProperty(this, "quantityCount", _descriptor18, this);
    _initializerDefineProperty(this, "purchaseOrderToken", _descriptor19, this);
    _initializerDefineProperty(this, "transferOrderToken", _descriptor20, this);
    _initializerDefineProperty(this, "bulkAdjustToken", _descriptor21, this);
    _initializerDefineProperty(this, "totalCost", _descriptor22, this);
    _initializerDefineProperty(this, "isRecount", _descriptor23, this);
    _initializerDefineProperty(this, "isCostEditable", _descriptor24, this);
    _initializerDefineProperty(this, "isVendorEditable", _descriptor25, this);
    _initializerDefineProperty(this, "totalSalesPrice", _descriptor26, this);
  }
  // Computed helpers
  get adjustment() {
    if (this.isRecount) {
      return this.inventoryEvent.inferredAdjustment;
    }
    return this.inventoryEvent.adjustment;
  }

  // If a received InventoryEvent has an associated stock conversion,
  // the receive was done in a different unit (nonstockable unit) than the item's default unit
  // Values related to the nonstockable unit are stored in the rootAdjustmentInformation object
  get isReceivedWithStockConversion() {
    return this.eventType === InventoryEventType.RECEIVED && this.rootAdjustmentInformation?.compositionType === CompositionType.STOCK_CONVERSION;
  }
  get adjustmentToken() {
    if (this.isReceivedWithStockConversion) {
      return this.rootAdjustmentToken;
    }
    return this.adjustment?.token;
  }
  get measurementUnit() {
    if (this.isReceivedWithStockConversion) {
      return this.rootAdjustmentInformation.measurementUnit;
    }
    return this.inventoryEvent.measurementUnit;
  }
  get quantity() {
    return this.getFromAdjustmentOrCount('quantity', 'quantity');
  }
  get quantityDecimal() {
    if (this.isReceivedWithStockConversion) {
      return DecimalStockCount.fromString(this.rootAdjustmentInformation.quantityDecimal);
    }
    return DecimalStockCount.fromString(this.getFromAdjustmentOrCount('quantityDecimal', 'quantityDecimal'));
  }
  get adjustmentQuantityDecimal() {
    return DecimalStockCount.fromString(this.adjustment.quantityDecimal);
  }
  get maxEditableQuantityDecimal() {
    if (this.maxEditableQuantity) {
      // This conversion from inventory quantity to decimal stock count isn't safe in the general case because
      // negatives are handled differently by each object. It's safe in this case because maxEditableQuantity
      // will always be positive.
      return new DecimalStockCount({
        _integer: this.maxEditableQuantity.count || 0,
        _decimal: this.maxEditableQuantity.fractionalCount || 0
      });
    } else {
      return null;
    }
  }
  get fromUnitToken() {
    return this.getFromAdjustmentOrCount('fromState.unitToken', 'state.unitToken');
  }
  get toUnitToken() {
    return this.getFromAdjustmentOrCount('toState.unitToken', 'state.unitToken');
  }
  get occurredAt() {
    return this.getFromAdjustmentOrCount('occurredAt', 'countedAt');
  }
  get employeeToken() {
    return this.getFromAdjustmentOrCount('adjustedBy', 'countedBy');
  }
  get displayName() {
    return formatName(this);
  }
  // The adjustment model has two fields for unit cost, `cost` and `unitCost`.
  // For receives with stock conversions, we have to derive the unit cost of the nonstockable unit
  // from the total cost and quantity of the nonstockable unit.
  // For consistency, we set both cost and unitCost here to the derived unit cost for receives with stock conversions.
  // And for other cases, we set it to the value from the adjustment model.

  get cost() {
    if (this.isReceivedWithStockConversion) {
      return this.adjustment?.totalCost ? this.adjustment.totalCost.divide(this.quantityDecimal) : undefined;
    }
    return this.adjustment?.cost;
  }
  get unitCost() {
    if (this.isReceivedWithStockConversion) {
      return this.adjustment?.totalCost ? this.adjustment.totalCost.divide(this.quantityDecimal) : undefined;
    }
    return this.adjustment?.unitCost;
  }
  get isManualReceive() {
    return this.eventType === InventoryEventType.RECEIVED && isEmpty(this.purchaseOrderToken);
  }
  get isPositiveRecount() {
    if (this.isRecount) {
      return this.adjustment?.fromState?.sqState === 'NONE' && this.adjustment?.toState?.sqState === 'IN_STOCK' && !this.adjustmentQuantityDecimal.isZero();
    }
    return false;
  }
  get isDamagedReturn() {
    return this.adjustment?.fromState?.sqState === 'RETURNED_BY_CUSTOMER' && this.adjustment?.toState?.sqState === 'WASTE';
  }
  get isUnlinkedRestock() {
    const fromState = this.adjustment?.fromState?.sqState;
    const toState = this.adjustment?.toState?.sqState;
    return fromState === 'UNLINKED_RETURN' && toState === 'IN_STOCK';
  }
  get isCountEditable() {
    if (this.isManualReceive || this.isUnlinkedRestock || countEditableEventTypes.has(this.eventType)) {
      return true;
    }
    return this.maxEditableQuantity;
  }
  get isWontFulfilTransferOrder() {
    return this.transferOrderToken && this.eventType === InventoryEventType.TRANSFER && this.adjustment?.fromState?.sqState === 'IN_TRANSIT' && this.adjustment?.toState?.sqState === 'IN_STOCK' && this.fromUnitToken !== this.toUnitToken;
  }
  get isReceivedTransferOrder() {
    return this.transferOrderToken && this.eventType === InventoryEventType.TRANSFER && this.adjustment?.fromState?.sqState === 'IN_TRANSIT' && this.adjustment?.toState?.sqState === 'IN_STOCK' && this.fromUnitToken === this.toUnitToken;
  }
  // Helper function to access the oneof adjustment / count.
  getFromAdjustmentOrCount(adjustmentProperty, countProperty) {
    const count = this.stockCount;
    if (!isNone(count)) {
      return get(count, countProperty);
    }
    const adjustment = this.adjustment;
    if (!isNone(adjustment)) {
      return get(adjustment, adjustmentProperty);
    }
    return undefined;
  }
  updateEditableFields(newQuantity, newCost, newVendor) {
    if (this.isCountEditable) {
      const adjustmentWithQuantity = this.isReceivedWithStockConversion ? this.rootAdjustmentInformation : this.adjustment;
      adjustmentWithQuantity.set('quantityDecimal', newQuantity.toString());
    }
    if (this.isCostEditable) {
      const newTotalCost = isNone(newCost) ? null : newCost.multiply(newQuantity);
      const adjustment = this.adjustment;
      if (!isNone(adjustment)) {
        const adjustmentWithUnitCost = this.isReceivedWithStockConversion ? this.rootAdjustmentInformation : this.adjustment;
        adjustmentWithUnitCost.set('cost', newCost);
        adjustmentWithUnitCost.set('unitCost', newCost);
        adjustment.set('totalCost', newTotalCost);
      }
    }
    if (this.isVendorEditable) {
      this.inventoryEvent.set('vendors', [InventoryEventVendor.fromVendorModel(newVendor)].filter(vendor => !isNone(vendor)));
    }
  }
  get isUntrackedSale() {
    return this.eventType === InventoryEventType.SALE && this.adjustment?.fromState?.sqState === 'UNTRACKED' && (this.adjustment?.toState?.sqState === 'SOLD' || this.adjustment?.toState?.sqState === 'COMPOSED');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "eventType", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "stockCount", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "itemName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "variationName", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "variationSku", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "variationUpc", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "defaultCost", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "componentInformation", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "rootAdjustmentInformation", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "defaultVendor", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "objectDeleted", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "connectOauthClientName", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "maxEditableQuantity", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "vendors", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "linkedRestockOriginalSaleUnitToken", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "adjustment", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "adjustment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReceivedWithStockConversion", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "isReceivedWithStockConversion"), _class.prototype), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "rootAdjustmentToken", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "adjustmentToken", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "adjustmentToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "measurementUnit", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "measurementUnit"), _class.prototype), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "productToken", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "quantity", [_dec22], Object.getOwnPropertyDescriptor(_class.prototype, "quantity"), _class.prototype), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "quantityCount", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "quantityDecimal", [_dec24], Object.getOwnPropertyDescriptor(_class.prototype, "quantityDecimal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "adjustmentQuantityDecimal", [_dec25], Object.getOwnPropertyDescriptor(_class.prototype, "adjustmentQuantityDecimal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxEditableQuantityDecimal", [_dec26], Object.getOwnPropertyDescriptor(_class.prototype, "maxEditableQuantityDecimal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fromUnitToken", [_dec27], Object.getOwnPropertyDescriptor(_class.prototype, "fromUnitToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toUnitToken", [_dec28], Object.getOwnPropertyDescriptor(_class.prototype, "toUnitToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "occurredAt", [_dec29], Object.getOwnPropertyDescriptor(_class.prototype, "occurredAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "employeeToken", [_dec30], Object.getOwnPropertyDescriptor(_class.prototype, "employeeToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayName", [_dec31], Object.getOwnPropertyDescriptor(_class.prototype, "displayName"), _class.prototype), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "purchaseOrderToken", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "transferOrderToken", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "bulkAdjustToken", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "totalCost", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "cost", [_dec36], Object.getOwnPropertyDescriptor(_class.prototype, "cost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unitCost", [_dec37], Object.getOwnPropertyDescriptor(_class.prototype, "unitCost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isManualReceive", [_dec38], Object.getOwnPropertyDescriptor(_class.prototype, "isManualReceive"), _class.prototype), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "isRecount", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isPositiveRecount", [_dec40], Object.getOwnPropertyDescriptor(_class.prototype, "isPositiveRecount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDamagedReturn", [_dec41], Object.getOwnPropertyDescriptor(_class.prototype, "isDamagedReturn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUnlinkedRestock", [_dec42], Object.getOwnPropertyDescriptor(_class.prototype, "isUnlinkedRestock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCountEditable", [_dec43], Object.getOwnPropertyDescriptor(_class.prototype, "isCountEditable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWontFulfilTransferOrder", [_dec44], Object.getOwnPropertyDescriptor(_class.prototype, "isWontFulfilTransferOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReceivedTransferOrder", [_dec45], Object.getOwnPropertyDescriptor(_class.prototype, "isReceivedTransferOrder"), _class.prototype), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "isCostEditable", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "isVendorEditable", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "totalSalesPrice", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isUntrackedSale", [_dec49], Object.getOwnPropertyDescriptor(_class.prototype, "isUntrackedSale"), _class.prototype), _class);
export { InventoryEventWrapper as default };